// ** React Imports
import { useEffect, useState } from 'react'
import Image from 'next/image'

// ** Next Import
import { useRouter } from 'next/router'

// ** Hook Imports
import { useAuth } from 'src/hooks/useAuth'

import { getAllUserDevice, verifyCurrentType } from '/src/@api/login'
import { useTranslation } from 'src/utils/i18n'
import { useDispatch } from 'react-redux'
import { getNotBindOrder, iosLoginReport } from 'src/@api/login'
import { redirectIfShouldBuyPackage, redirectToChooseDevice } from 'src/utils/chooseDeviceRedirect'
import { bootstrapDeviceSelection } from 'src/utils/bootstrapDeviceSelection'
import { EXPIRED_PURCHASE_PATH } from 'src/components/expired-purchase-guide/constants'
import { loadUserEntryFlags, resolveUserEntry, USER_ENTRY } from 'src/utils/userEntryGate'
import {
  pickPreferredSelectableDevice,
  resolveInitialEntry
} from 'src/utils/subscriptionStatus'
import dayjs from 'dayjs'
import { messageInfo } from 'src/components/Message'
import { appendSetupQuery, cacheBindOrder } from 'src/utils/resolveCurrentOrderId'
import { filterValidUnboundOrders } from 'src/utils/chooseDeviceRedirect'

const dashboardPathByMode = mode => {
  if (mode === 'Android-Cloud') return '/android/dashboard'
  if (mode === 'Android-Local') return '/android/local/dashboard'

  return '/dashboard'
}

/**
 *  Set Home URL based on User Roles
 */
export const getHomeRoute = role => {
  if (role === 'client') return '/acl'
  else if (localStorage.getItem('currentMode') === 'Android-Cloud') return '/android/dashboard'
  else return '/dashboard'
}

const Home = () => {
  const { t } = useTranslation('common')

  //当前页面语种
  const [currentLanguage, setCurrentLanguage] = useState('/')

  // useEffect(() => {
  //   // 函数用于更新 currentLanguage
  //   const updateLanguage = () => {
  //     const url = window.location.pathname

  //     // 使用正则表达式匹配语言代码，包括语言代码后可能没有任何路径的情况
  //     const match = url.match(/^\/(de|kr|it-ch|pt|jp|fr|es|tr|ar|[a-zA-Z]{2})($|\/)/)
  //     const language = match ? `/${match[1]}` : '/'
  //     setCurrentLanguage(language)
  //   }

  //   // 初始化时设置语言
  //   updateLanguage()

  //   // 监听浏览器历史记录的变化
  //   window.addEventListener('popstate', updateLanguage)

  //   // 处理前进和后退操作
  //   const handleNavigation = () => {
  //     updateLanguage()
  //   }

  //   // 监听 pushState 和 replaceState
  //   const originalPushState = window.history.pushState
  //   const originalReplaceState = window.history.replaceState

  //   window.history.pushState = function () {
  //     originalPushState.apply(this, arguments)
  //     handleNavigation()
  //   }

  //   window.history.replaceState = function () {
  //     originalReplaceState.apply(this, arguments)
  //     handleNavigation()
  //   }

  //   // 清理监听器
  //   return () => {
  //     window.removeEventListener('popstate', updateLanguage)
  //     window.history.pushState = originalPushState
  //     window.history.replaceState = originalReplaceState
  //   }
  // }, []) // 空依赖数组，表示只在组件加载时和卸载时执行一次

  // ** Hooks
  const dispatch = useDispatch()
  const auth = useAuth()
  const router = useRouter()

  let [loading, setLoading] = useState(true)

  const allUserDevice = async () => {
    return await getAllUserDevice({})
  }

  // 校验
  const verify = async type => {
    let allDeviceUser = await allUserDevice()
    const data = Array.isArray(allDeviceUser.data) ? [...allDeviceUser.data] : []
    const all = data.sort((a, b) => dayjs(b.createdAt) - dayjs(a.createdAt))

    if (type == 'iOS-Cloud') {
      if (all !== null && all.length > 0 && all[0]) {
        const _data = all.filter(row => row.platform_type === 'iOS-Cloud')
        // 永不回退到超 30 天设备
        const selectedDevice = pickPreferredSelectableDevice(_data)

        if (selectedDevice) {
          bootstrapDeviceSelection({
            dispatch,
            device: selectedDevice,
            platformType: type,
            allDevices: all
          })
        } else {
          // 没有可选绑定设备，验证是否有未绑定账单
          const res = await getNotBindOrder({})
          if (res.data && res.data.length) {
            bootstrapDeviceSelection({
              dispatch,
              device: null,
              platformType: type,
              allDevices: all
            })
          } else {
            throw new Error('No not bind order')
          }
        }
      } else {
        const res = await getNotBindOrder({})
        if (res.data && res.data.length) {
          bootstrapDeviceSelection({
            dispatch,
            device: null,
            platformType: type,
            allDevices: []
          })
        } else {
          throw new Error('No not bind order')
        }
      }
    } else if (type.indexOf('Android') >= 0) {
      if (all !== null && all.length > 0) {
        const _data = all.filter(row => row.platform_type === type)
        const selectedDevice = pickPreferredSelectableDevice(_data)

        bootstrapDeviceSelection({
          dispatch,
          device: selectedDevice,
          platformType: type,
          allDevices: all
        })
      } else {
        bootstrapDeviceSelection({
          dispatch,
          device: null,
          platformType: type,
          allDevices: []
        })
      }
    }
  }

  // useEffect(() => {
  //   if (auth.user && auth.user.role) {
  //     const homeRoute = getHomeRoute(auth.user.role)

  //     const type = async () => {
  //       let { data, order, deviceMany } = await verifyCurrentType()
  //       localStorage.setItem('deviceMany', deviceMany)

  //       // 类型
  //       if (data === 'not bind device' || order.length > 0 || deviceMany) {
  //         setLoading(false)

  //         return
  //       }

  //       // 定义路径映射
  //       const paths = {
  //         'iOS-Cloud': '/dashboard',
  //         'Android-Cloud': '/android/dashboard',
  //         'Android-Local': '/android/local/dashboard'
  //       }

  //       // 获取路径
  //       const path = paths[data]

  //       if (path) {
  //         // 验证数据
  //         verify(data).then(() => {
  //           // 更新 localStorage
  //           window.localStorage.setItem('currentMode', data)

  //           // 根据 currentLanguage 决定 fullPath
  //           const fullPath = currentLanguage === '/' ? path : `${currentLanguage}${path}`
  //           window.location.assign(fullPath)
  //         })
  //       }
  //     }

  //     type()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentLanguage])

  useEffect(() => {
    if (!auth.user?.role) return

    const type = async () => {
        // 先查设备：已绑定设备应进 dashboard，不能仅因无未绑定订单被踢去买套餐
        const allDeviceUser = await getAllUserDevice({}) // 获取所有设备用户
        const data = (Array.isArray(allDeviceUser.data) ? [...allDeviceUser.data] : []).sort((a, b) => dayjs(b.createdAt) - dayjs(a.createdAt)) // 检查数据是否是数组并按绑定时间排序
        const notBindOrder = await getNotBindOrder().catch(() => ({ data: [] }))
        const validUnbound = filterValidUnboundOrders(notBindOrder?.data)

        // 入口优先级：未购买 → 购买页；买过且全部订单过期超 30 天 → 过期页；其余走设备流程
        const flags = await loadUserEntryFlags()
        const entryType = resolveUserEntry({ flags, devices: data, validUnboundOrders: validUnbound })

        if (entryType === USER_ENTRY.BUY) {
          redirectToChooseDevice()
          setLoading(false)

          return
        }

        if (entryType === USER_ENTRY.EXPIRED) {
          window.location.assign(EXPIRED_PURCHASE_PATH)
          setLoading(false)

          return
        }

        if (data[0]) {
          const currentModeStr = localStorage.getItem('currentMode')
          const currentMode = currentModeStr || null
          const DeviceUserStr = localStorage.getItem('DeviceUser')
          const DeviceUser = DeviceUserStr ? JSON.parse(DeviceUserStr) : null

          const matchedDevice = data.find(
            i =>
              (DeviceUser?.device_id != null &&
                DeviceUser?.device_id !== '' &&
                (String(i?.id) === String(DeviceUser.device_id) ||
                  String(i?.device_id) === String(DeviceUser.device_id))) ||
              i?.iCloud_username === DeviceUser?.username
          )

          // active/grace 设备 > 未绑单 > 空态；「全部过期超 30 天」已由入口 gate 处理
          const entry = resolveInitialEntry({
            devices: data,
            validUnboundOrders: validUnbound,
            preferredMode: currentMode,
            preferredDevice: matchedDevice || null
          })

          if (entry.type === 'unbound' || entry.type === 'empty') {
            let setupOrderId = null
            if (validUnbound.length >= 1) {
              setupOrderId = cacheBindOrder(validUnbound[0])
            } else if (await redirectIfShouldBuyPackage(notBindOrder)) {
              setLoading(false)

              return
            }

            bootstrapDeviceSelection({
              dispatch,
              device: null,
              platformType: currentMode || 'iOS-Cloud',
              allDevices: data
            })
            window.location.assign(appendSetupQuery('/setup', setupOrderId || undefined))
            setLoading(false)

            return
          }

          const defaultDevice = entry.device
          window.localStorage.setItem('currentMode', defaultDevice.platform_type)
          await verify(defaultDevice.platform_type)
          window.location.assign(dashboardPathByMode(defaultDevice.platform_type))
        } else {
          const search = typeof window !== 'undefined' ? window.location.search : ''
          const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
          const queryOrderId = params.get('orderId') || params.get('order_id')

          if (params.get('from_app') === '1' && !queryOrderId) {
            messageInfo({ content: 'Current order is missing' })
            setLoading(false)

            return
          }

          // 无设备时：无有效未绑定订单才去买套餐，否则走绑定 setup
          // 已有明确 orderId 时直接进 setup，避免被未绑定列表为空踢去买套餐
          let setupOrderId = queryOrderId
          if (!setupOrderId) {
            if (await redirectIfShouldBuyPackage(notBindOrder)) {
              setLoading(false)

              return
            }

            // 登录进 setup：默认选中第一张有效未绑单（排除过期单干扰计数）
            if (validUnbound.length >= 1) {
              setupOrderId = cacheBindOrder(validUnbound[0])
            }
          }

          window.location.assign(appendSetupQuery('/setup', setupOrderId || undefined))
        }
        setLoading(false)
      }

      type()
  }, [auth.user])

  // 选择平台
  const SelectPlatform = () => {
    return (
      <>
        <h2 className='text-[24px] text-[#000] font-[Poppins] font-[600] leading-[36px] text-center mx-[15px] Mlg:mt-[60px] mt-[78px] mb-[37px]'>
          {t('Select the type of device want to monitoring')}
        </h2>

        {/* <Grid container spacing={6} style={{ marginTop: '30px' }}>
          <Grid item xs={12} md={12} lg={3}></Grid>
          <Grid item xs={12} md={12} lg={3} style={{ padding: '0 3rem', paddingBottom: '24px' }}>
            <Card
              style={{ cursor: 'pointer', background: '#242951', minHeight: '130px' }}
              onClick={() => {
                verify('iOS-Cloud').then(() => {
                  window.localStorage.setItem('currentMode', 'iOS-Cloud')
                  const path = currentLanguage === '/' ? '/dashboard' : `${currentLanguage}/dashboard`
                  window.location.assign(path)
                })
              }}
            >
              <CardContent>
                <div style={{ display: 'flex', justifyContent: 'center', paddingRight: '12px' }}>
                  <Icon icon='ic:baseline-apple' color='#B2BCD2' fontSize='54' />
                </div>
                <div
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <span style={{ fontSize: '18px', textAlign: 'center', color: '#fff' }}>{t('iOS')}</span>
                  <Icon icon='ic:baseline-navigate-next' color='#fff' />
                </div>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={12} lg={3} style={{ cursor: 'pointer', padding: '0 3rem', paddingBottom: '24px' }}>
            <Card
              style={{ cursor: 'pointer', background: '#242951', minHeight: '130px' }}
              onClick={async () => {
                console.log('12')

                // 获取所有设备用户
                const allDeviceUser = await allUserDevice()

                // 检查数据是否是数组
                const data = Array.isArray(allDeviceUser.data) ? allDeviceUser.data : []

                // 确定要跳转的路径
                let path = '/android/classification' // 默认路径

                if (data.some(row => row.platform_type === 'Android-Cloud')) {
                  verify('Android-Cloud').then(() => {
                    window.localStorage.setItem('currentMode', 'Android-Cloud')
                    path = '/android/dashboard'

                    // 拼接完整路径
                    const fullPath = currentLanguage === '/' ? path : `${currentLanguage}${path}`

                    // 跳转到目标路径
                    window.location.assign(fullPath)
                  })

                  return
                } else if (data.some(row => row.platform_type === 'Android-Local')) {
                  verify('Android-Local').then(() => {
                    window.localStorage.setItem('currentMode', 'Android-Local')
                    path = '/android/local/dashboard'

                    // 拼接完整路径
                    const fullPath = currentLanguage === '/' ? path : `${currentLanguage}${path}`

                    // 跳转到目标路径
                    window.location.assign(fullPath)
                  })

                  return
                }

                window.localStorage.setItem('currentMode', 'Android-Cloud')

                // 拼接完整路径
                const fullPath = currentLanguage === '/' ? path : `${currentLanguage}${path}`

                // 跳转到目标路径
                window.location.assign(fullPath)
              }}
            >
              <CardContent>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingRight: '12px',
                    height: '54px'
                  }}
                >
                  <Icon icon='bi:android2' color='#B2BCD2' fontSize='40' />
                </div>
                <div
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <span style={{ fontSize: '18px', textAlign: 'center', color: '#fff' }}>{t('Android')}</span>
                  <Icon icon='ic:baseline-navigate-next' color='#fff' />
                </div>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={12} lg={3}></Grid>
        </Grid> */}

        {/* 新ui */}
        <div className='max-w-[728px] grid grid-cols-1 smjs:grid-cols-2 gap-[30px] mx-5 smjs:mx-auto'>
          <div
            className='w-full h-[130px] cursor-pointer flex flex-col justify-center items-center [border:1px_solid_#0481FF] rounded-[10px]
          [background:linear-gradient(180deg,#ECF3FE_0%,#FDFEFF_100%)] hover:[background:linear-gradient(180deg,#D9E8FF_0%,#ECF3FE_100%)]'
            onClick={() => {
              // 上传ios日志
              iosLoginReport({
                "platform": "ios-icloud",
                "site": "spyx",
                "s_1": 1
              })


              verify('iOS-Cloud').then(() => {
                window.localStorage.setItem('currentMode', 'iOS-Cloud')
                const path = '/dashboard'
                window.location.assign(path)
              })
            }}
          >
            <Image src='/images/bind/ios.svg' alt='ios' width={41} height={48} className='w-[41px] h-[48px]' />
            <div className='flex justify-center items-center mt-[9px]'>
              <span className='text-[20px] text-[#222222] font-[Poppins] font-bold leading-[30px]'>{t('iOS')}</span>
              <Image src='/images/bind/arrow.svg' alt='arrow' width={6} height={12} className='w-[6.01px] h-[11.66px] ml-2' />
            </div>
          </div>

          <div
            className='w-full h-[130px] cursor-pointer flex flex-col justify-center items-center [border:1px_solid_#0481FF] rounded-[10px]
          [background:linear-gradient(180deg,#ECF3FE_0%,#FDFEFF_100%)] hover:[background:linear-gradient(180deg,#D9E8FF_0%,#ECF3FE_100%)]'
            onClick={async () => {

              // 获取所有设备用户
              const allDeviceUser = await allUserDevice()

              // 检查数据是否是数组
              const data = Array.isArray(allDeviceUser.data) ? allDeviceUser.data : []

              // 确定要跳转的路径
              let path = '/android/classification' // 默认路径

              if (data.some(row => row.platform_type === 'Android-Cloud')) {
                verify('Android-Cloud').then(() => {
                  window.localStorage.setItem('currentMode', 'Android-Cloud')
                  path = '/android/dashboard'

                  // 跳转到目标路径
                  window.location.assign(path)
                })

                return
              } else if (data.some(row => row.platform_type === 'Android-Local')) {
                verify('Android-Local').then(() => {
                  window.localStorage.setItem('currentMode', 'Android-Local')
                  path = '/android/local/dashboard'

                  // 跳转到目标路径
                  window.location.assign(path)
                })

                return
              }

              window.localStorage.setItem('currentMode', 'Android-Cloud')

              // 跳转到目标路径
              window.location.assign(path)
            }}
          >
            <Image src='/images/bind/android.svg' alt='android' width={42} height={50} className='w-[42.31px] h-[50px]' />
            <div className='flex justify-center items-center mt-[9px]'>
              <span className='text-[20px] text-[#222222] font-[Poppins] font-bold leading-[30px]'>{t('Android')}</span>
              <Image src='/images/bind/arrow.svg' alt='arrow' width={6} height={12} className='w-[6.01px] h-[11.66px] ml-2' />
            </div>
          </div>
        </div>
      </>
    )
  }

  return <>
    {/* {loading ? <Spinner sx={{ height: '100%' }} /> : <SelectPlatform />} */}
  </>
}

export default Home